import ToastContainer from './index';
import eventBus from './bus';

const allTimeout = [];

const Api = (Vue, globalOptions = {}) => {
  return {
    openSingleToast(propsData) {
      allTimeout.forEach(timeout => {
        clearTimeout(timeout);
      });
      this.clear();
      allTimeout.push(setTimeout(() => {
        return new (Vue.extend(ToastContainer))({
          el: document.createElement('div'),
          propsData,
        });
      }, 250));
    },
    openMultipleToast(propsData) {
      return new (Vue.extend(ToastContainer))({
        el: document.createElement('div'),
        propsData,
      });
    },
    open(options) {
      let description;
      if (typeof options === 'string') description = options;

      const defaultOptions = {
        description,
      };

      let propsData = { ...defaultOptions, ...globalOptions };
      if (typeof options !== 'string') propsData = { ...propsData, ...options };

      if (options.singleToast) {
        return this.openSingleToast(propsData);
      }
      return this.openMultipleToast(propsData);
    },
    clear() {
      eventBus.emit('toast-clear');
    },
    success(message, options = {}) {
      return this.open({
        description: message,
        type: 'success',
        ...options,
      });
    },
    error(message, options = {}) {
      return this.open({
        description: message,
        type: 'error',
        ...options,
      });
    },
    info(message, options = {}) {
      return this.open({
        description: message,
        type: 'info',
        ...options,
      });
    },
    warning(message, options = {}) {
      return this.open({
        description: message,
        type: 'warning',
        ...options,
      });
    },
    default(message, options = {}) {
      return this.open({
        description: message,
        type: 'default',
        ...options,
      });
    },
  };
};

export default Api;
